import { t } from 'i18next';

export enum UserRole {
  OWNER = 'owner',
  USER = 'user',
}

export const UserRoleLabel: Record<UserRole, string> = {
  [UserRole.OWNER]: t('labelOwner'),
  [UserRole.USER]: t('labelUser'),
};

export enum SettingValue {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export const SettingValueLabel: Record<SettingValue, string> = {
  [SettingValue.ENABLED]: t('labelEnabled'),
  [SettingValue.DISABLED]: t('labelDisabled'),
};
